import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';
import * as i2 from '@adeo/ngx-kozikaza-api';
import { BaseService, KOZIKAZA_API_OPTIONS, createSubResourceObservable } from '@adeo/ngx-kozikaza-api';
import { switchMap, map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';

var ProductType;
(function (ProductType) {
    ProductType["ONE_TIME"] = "one_time";
    ProductType["SUBSCRIPTION"] = "subscription";
})(ProductType || (ProductType = {}));

var UserKazaplanServiceProductSubResource;
(function (UserKazaplanServiceProductSubResource) {
    UserKazaplanServiceProductSubResource.Product = 'product';
})(UserKazaplanServiceProductSubResource || (UserKazaplanServiceProductSubResource = {}));

var UserKazaplanServiceStatus;
(function (UserKazaplanServiceStatus) {
    UserKazaplanServiceStatus["FREE"] = "freee";
    UserKazaplanServiceStatus["PREMIUM"] = "premium";
})(UserKazaplanServiceStatus || (UserKazaplanServiceStatus = {}));

class BillingInformationService extends BaseService {
    platformId;
    static endpoint = '/billing_informations';
    static endpointPrefix = '/payment';
    getWebServiceName() {
        return 'BillingInformationService';
    }
    constructor(options, httpClient, platformId, cache, logger) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
    }
    getBillingInformations(options) {
        return this.getNoHydraMember(BillingInformationService.endpointPrefix + BillingInformationService.endpoint, options);
    }
    postBillingInformations(billingInformation, options) {
        return this.postNoHydraMember(BillingInformationService.endpointPrefix + BillingInformationService.endpoint, billingInformation, options).pipe(switchMap(() => this.getBillingInformations(options)));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: BillingInformationService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: BillingInformationService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: BillingInformationService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }]; } });

class InvoiceService extends BaseService {
    platformId;
    static endpoint = '/invoices';
    static endpointPrefix = '/payment';
    getWebServiceName() {
        return 'InvoiceService';
    }
    constructor(options, httpClient, platformId, cache, logger) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
    }
    getInvoices(options) {
        return this.getNoHydraMember(InvoiceService.endpointPrefix + InvoiceService.endpoint, options);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: InvoiceService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: InvoiceService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: InvoiceService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }]; } });

class ProductService extends BaseService {
    platformId;
    static endpoint = '/products';
    static endpointPrefix = '/payment';
    getWebServiceName() {
        return 'ProductService';
    }
    constructor(options, httpClient, platformId, cache, logger) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
    }
    getProducts(subResources, options) {
        return this.getResources(ProductService.endpointPrefix + ProductService.endpoint, subResources, options);
    }
    getProduct(product, subResources, options) {
        return this.getResource(ProductService.endpointPrefix +
            (typeof product === 'string' ? product : product['@id']), subResources, options);
    }
    purchaseProduct(product, options) {
        return this.postNoHydraMember(ProductService.endpointPrefix +
            (typeof product === 'string' ? product : product['@id']) +
            '/purchase', {}, options);
    }
    cancelProduct(product, options) {
        return this.postNoHydraMember(ProductService.endpointPrefix +
            (typeof product === 'string' ? product : product['@id']) +
            '/cancel', {}, options);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProductService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProductService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProductService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }]; } });

class UserKazaplanServiceService extends BaseService {
    platformId;
    static endpoint = '/user_kazaplan_services';
    static endpointPrefix = '/payment';
    getWebServiceName() {
        return 'UserKazaplanServiceService';
    }
    constructor(options, httpClient, platformId, cache, logger) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
    }
    getUserKazaplanServices(subResources, options) {
        return this.getResources(UserKazaplanServiceService.endpointPrefix + UserKazaplanServiceService.endpoint, subResources, options);
    }
    getUserKazaplanService(userKazaplanService, subResources, options) {
        return this.getResource(UserKazaplanServiceService.endpointPrefix +
            (typeof userKazaplanService === 'string' ? userKazaplanService : userKazaplanService['@id']), subResources, options);
    }
    getPlansEditable(planId, options) {
        return this.getNoHydraMember(UserKazaplanServiceService.endpointPrefix + `/plans/${planId}`, options);
    }
    getPlansCreatable(options) {
        return this.getNoHydraMember(UserKazaplanServiceService.endpointPrefix + '/plans', options);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: UserKazaplanServiceService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: UserKazaplanServiceService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: UserKazaplanServiceService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }]; } });

class UserKazaplanServiceProductService extends BaseService {
    platformId;
    injector;
    static endpoint = '/user_kazaplan_service_products';
    static endpointPrefix = '/payment';
    getWebServiceName() {
        return 'UserKazaplanServiceProductService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getUserKazaplanServiceProducts(subResources, options) {
        return this.getResources(UserKazaplanServiceProductService.endpointPrefix + UserKazaplanServiceProductService.endpoint, subResources, options);
    }
    getUserKazaplanServiceProduct(userKazaplanServiceProduct, subResources, options) {
        return this.getResource(UserKazaplanServiceProductService.endpointPrefix +
            (typeof userKazaplanServiceProduct === 'string' ? userKazaplanServiceProduct : userKazaplanServiceProduct['@id']), subResources, options);
    }
    getSubResourceObservable(userKazaplanServiceProduct, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case UserKazaplanServiceProductSubResource.Product:
                if (userKazaplanServiceProduct.product) {
                    return createSubResourceObservable(this.injector.get(ProductService).getProduct(userKazaplanServiceProduct.product, subResourceRequest[1], options), options)
                        .pipe(map((product) => {
                        userKazaplanServiceProduct.product = product;
                        return userKazaplanServiceProduct;
                    }));
                }
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: UserKazaplanServiceProductService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: UserKazaplanServiceProductService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: UserKazaplanServiceProductService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

const WEB_SERVICES = [
    InvoiceService,
    ProductService,
    UserKazaplanServiceService,
    UserKazaplanServiceProductService,
    BillingInformationService,
];
class PaymentApiModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: PaymentApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.8", ngImport: i0, type: PaymentApiModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: PaymentApiModule, providers: [
            ...WEB_SERVICES,
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: PaymentApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    providers: [
                        ...WEB_SERVICES,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BillingInformationService, InvoiceService, PaymentApiModule, ProductService, ProductType, UserKazaplanServiceProductService, UserKazaplanServiceProductSubResource, UserKazaplanServiceService, UserKazaplanServiceStatus };
